/* template */
<template><div class="order-effecting"><div class="card-header"><div class="order-title">{{ goodsName }}</div></div><div class="coupons"><coupon-ticket v-for="(item, index) in (coupons.unused)" :key="item['{{ item.id }}']" :coupon="(item)" :currency="(currency)" @coupon-click="onClick"/><coupon-ticket v-for="(item, index) in (coupons.used)" :key="item['{{ item.id }}']" :coupon="(item)" :currency="(currency)" used @coupon-click="onClick"/></div><div class="tips" v-if="(couponsTotal > 12)"><span class="tips-text">{{ $t('personal.showOnlySomeCoupons') }}</span></div><mpx-view @tap="goDache" class="main-btn" v-if="(btnText)"><div class="btn-elem"><div :class="([expireDay > 1000 ? 'expired-time_left' : ''])" class="expired-time"><span class="label">{{ $t('personal.expireIn') }}</span><down-time :expired-time="(expireTime)" :current-time="(currentTime)" :show-block="(downTimeProperties.showBlock)" :unit-obj="(downTimeProperties.unitObj)" :isShowDayEqualZero="(downTimeProperties.isShowDayEqualZero)" :padTime="(downTimeProperties.padTime)" :style-config="({                numStyle: {                  background: 'none',                  color: '#fff'                },                unitStyle: {                  color: '#fff'                },            })" :is-hour-level-down-time="(downTimeProperties.isHourLevelDownTime)" class="time"/></div><div class="action-text">{{ btnText }}</div></div></mpx-view><div class="time-tips-box" v-else><div class="time-icon"></div><div class="time-str">距失效：</div><down-time :expired-time="(expireTime)" :current-time="(currentTime)" :show-block="(downTimePropertiesLine.showBlock)" :unit-obj="(downTimePropertiesLine.unitObj)" :isShowDayEqualZero="(downTimePropertiesLine.isShowDayEqualZero)" :padTime="(downTimePropertiesLine.padTime)" :styleConfig="(downTimePropertiesLine.styleConfig)" :gridNumAmounts="(downTimePropertiesLine.gridNumAmounts)" :style-config="({            numStyle: {              background: 'none',              color: '#fff'            },            unitStyle: {              color: '#fff'            },        })" :is-hour-level-down-time="(downTimePropertiesLine.isHourLevelDownTime)" class="time"/></div><div class="card-bottom"><div class="card-bottom-content"><div class="left-content"><span class="value">{{ $t('personal.total') }} {{ currencySymbol }}{{ displayPrice }}</span><span class="order-time">{{ $t('personal.purchasedOn', { time: displayOrderTime }) }}</span></div><div class="right-content"><mpx-text @tap="onClick" class="go-detail">{{ $t('personal.viewDetail') }}</mpx-text><arrow-right color="#181818" class="arrow"/></div></div></div></div></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"m23a1b4ec"}'>
@import '../../../lib/stylus/variable.styl'

.order-effecting
  width 686rpx
  margin 0 auto 28rpx auto
  background-image linear-gradient(149deg, #FFFFFF 0%, #FFFDF5 99%)
  box-shadow 0 10rpx 20rpx 0 rgba(220, 220, 220, 0.49)
  border-radius 20rpx
.card-header
  width 626rpx
  height 100rpx
  padding 0 30rpx
  display flex
  flex-flow row nowrap
  align-items center
.order-title
  flex auto
  font-weight $fw-semi-bold
  font-size 32rpx
  color #000000
.money-saving
  flex none
  font-size 24rpx
  color #181818
  .value
    color #ffffff
    font-size 26rpx
    font-weight $fw-semi-bold
    display inline-block
    background-color #FF5600
    border-radius 5rpx
    padding 0 5rpx
    margin 0 6rpx
.coupons
  display flex
  flex-flow row wrap
  justify-content flex-start
  align-items flex-start
  padding-left 35rpx
.tips
  display flex
  flex-flow row nowrap
  justify-content center
  align-items center
  &:before, &:after
    content ''
    display block
    height 1px
    width 80px
    background-image linear-gradient(270deg, rgba(200, 200, 200, 0), rgba(151, 151, 151, .22))
  &:before
    background-image linear-gradient(90deg, rgba(200, 200, 200, 0), rgba(151, 151, 151, .22))
  .tips-text
    opacity 0.53
    font-size 20rpx
    color #686868
    margin 0 40rpx
.main-btn
  width 587rpx
  height 116rpx
  position relative
  margin 14rpx auto 50rpx
  &:after
    content ''
    display block
    width 587rpx
    height 116rpx
    opacity 0.26
    background-image linear-gradient(270deg, #FF5647 38%, #5D3587 59%)
    border-radius 50rpx
    position absolute
    bottom -20rpx
    left 0
    z-index 1
    filter blur(12rpx)
  .btn-elem
    width 587rpx
    height 116rpx
    background-image url('https://ut-static.udache.com/webx/fe-agility-wyc/W42koxevI-OAYC3WYjD6b.png')
    background-size 100% 100%
    position relative
    z-index 2
  .expired-time
    position absolute
    left 70rpx
    top 22rpx
    display flex
    flex-flow column nowrap
    justify-content center
    align-items center
    &.expired-time_left
      left 50rpx
    .label
      font-weight $fw-medium
      font-size 30rpx
      color #FFFFFF
      letter-spacing 0.38rpx
      background-image linear-gradient(270deg, #FFDDDD, #FFEFE0)
      -webkit-background-clip text
      -webkit-text-fill-color transparent
    .time
      opacity 0.76
      font-weight $fw-light
      font-size 20rpx
      color #FFEFF7
      letter-spacing 2rpx
  .action-text
    position absolute
    right 86rpx
    top 35rpx
    font-weight $fw-bold
    font-size 34rpx
    color #FFFFFF
    letter-spacing 1rpx
.time-tips-box
  display inline-flex
  align-items center
  justify-content: flex-start
  width auto
  height 40rpx
  border-radius: 10rpx
  background-image: linear-gradient(90deg, #FFE0D6 2%, #FFFFFF 100%);
  padding 0 6rpx 0 12rpx
  margin 18rpx 0 23rpx 35rpx
  box-sizing border-box
  font-family: PingFangSC-Medium;
  font-size: 24rpx;
  color: #000000;
  letter-spacing: 0;
  text-align: center;
  font-weight: 500;
  .time-icon
    width 24rpx
    height 24rpx
    background url('https://ut-static.udache.com/webx/fe-agility-wyc/nwDxIArTFO0Vmqvv3vBL9_icon.png') no-repeat
    background-size 100% 100%
    background-repeat no-repeat
  .time-str
    margin: 0 0.5rpx 0 12rpx
  .time_hight
    color: #FF0000;
    margin: 0 10.5rpx
  .time_hight1
    margin-left: 0
  .time-info
    display: flex

.card-bottom
  padding 0 35rpx
  .card-bottom-content
    height 78rpx
    // margin-top 50rpx
    border-top 1px dashed #cabcb8
    display flex
    flex-flow row nowrap
    align-items center
    .left-content
      flex auto
      .value, .order-time
        font-size 24rpx
        color #181818
      .value:after
        content ''
        display inline-block
        margin 0 12rpx
        width 1px
        height 16rpx
        background-color #CABCB8
    .right-content
      flex none
      .go-detail
        font-size 24rpx
        color #181818
        margin-right 8rpx
      .arrow
        width 9rpx
        height 16rpx
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "../../../../node_modules/@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentSrcMode = "wx"

import { createComponent } from '@mpxjs/core'
import { formatFen2Yuan } from '../../../lib/js/util'
import { GlobalEnv } from '../../../lib/webx'
import { EnumCouponType, EnumLang } from '../../../lib/webx/defines'
import { timestamp2ymdhms } from '../../../lib/webx/utils/format'
import { MixinCurrencySymbol } from '@didi/trade-sdk/lib/quartz.js'
import { TrackMap } from '../../../lib/webx/common_methods/track_map'
import { goDaCheF } from '../../../lib/webx/utils/guide_app_home'
import { getProdConfFromApollo, getformateLangMessage } from '../../../lib/webx/global_env/get_prod_config'
import { timeStampMs } from '@didi/trade-sdk'
import { is } from '@didi/webx-js'

const getCouponValue = (couponPackage, { isWashingCard } = {}) => {
  const {
    discount_type,
    discount_amount,
    discount,
  } = couponPackage
  if (discount_type === EnumCouponType.Reduction || (isWashingCard && discount_type === EnumCouponType.FixedPrice) || discount_type === EnumCouponType.Cap) {
    return !(discount_amount % 100)
      ? discount_amount / 100
      : (discount_amount / 100).toFixed(1)
  } else {
    if (GlobalEnv.lang !== EnumLang['en-US']) {
      return !(discount % 10) ? discount / 10 : (discount / 10).toFixed(1)
    } else {
      return `${100 - discount}%`
    }
  }
}

createComponent({
  name: 'OrderEffecting',
  mixins: [ MixinCurrencySymbol ],
  properties: {
    goodsName: String,
    packages: Array,
    expireTime: Number,
    currentTime: Number,
    price: Number,
    orderTime: Number,
    goodsId: [ String, Number ],
    productType: [ String, Number ],
    cardShow: Object,
    orderId: [ String, Number ],
  },
  data: {
    expireDay: 0,
    timer: null,
    offset: null,
  },
  attached() {
    this.offset = this.currentTime ? timeStampMs(this.currentTime) - new Date().getTime() : 0
    this.downTime()
  },
  computed: {
    downTimeProperties() {
      const downTimeProperties24 = {
        showBlock: [ 'd', 'h' ],
        unitObj: {
          d: '天',
          h: '小时',
        },
        isHourLevelDownTime: false,
        isShowDayEqualZero: false,
        padTime: false,
      }
      const downTimeProperties1 = {
        showBlock: [ 'h', 'm', 's' ],
        unitObj: {
          h: ':',
          m: ':',
          s: '',
        },
        isHourLevelDownTime: true,
        isShowDayEqualZero: true,
        padTime: true,
      }
      return this.expireDay >= 1 ? downTimeProperties24 : downTimeProperties1
    },
    downTimePropertiesLine() {
      const downTimeProperties24 = {
        showBlock: [ 'd', 'h' ],
        unitObj: {
          d: '天',
          h: '小时',
        },
        isHourLevelDownTime: false,
        isShowDayEqualZero: false,
        padTime: false,
        gridNumAmounts: 'single',
        styleConfig: {
          numStyle: {
            fontSize: '24rpx',
            color: '#FF0000',
            fontWeight: 'bolder',
            fontFamily: 'PingFangSC-Medium',
          },
          unitStyle: {
            fontFamily: 'PingFangSC-Medium',
            fontSize: '24rpx',
            color: '#000000',
            letterSpacing: '0',
            textAlign: 'center',
            margin: '0 5rpx',
            fontWeight: 'bolder',
          },
        },
      }
      const downTimeProperties1 = {
        showBlock: [ 'h', 'm', 's' ],
        unitObj: {
          h: ':',
          m: ':',
          s: '',
        },
        isHourLevelDownTime: true,
        isShowDayEqualZero: true,
        padTime: true,
        gridNumAmounts: 'single',
        styleConfig: {
          numStyle: {
            fontSize: '24rpx',
            color: '#FF0000',
            fontWeight: 'bolder',
            fontFamily: 'PingFangSC-Medium',
          },
          unitStyle: {
            fontFamily: 'PingFangSC-Medium',
            fontSize: '24rpx',
            color: '#000000',
            letterSpacing: '0',
            textAlign: 'center',
            margin: '0 5rpx',
            fontWeight: 'bolder',
          },
        },
      }
      return this.expireDay >= 1 ? downTimeProperties24 : downTimeProperties1
    },
    displayPrice() {
      return formatFen2Yuan(this.price)
    },
    displayOrderTime() {
      const {
        year,
        month,
        date,
      } = timestamp2ymdhms(this.orderTime * 1000)
      return `${year}.${month}.${date}`
    },
    couponsTotal() {
      return Array.isArray(this.packages)
        ? this.packages.reduce((prev, curr) => prev + curr.coupon_number, 0)
        : 0
    },
    coupons() {
      if (Array.isArray(this.packages) && this.packages.length) {
        const unused = []
        const used = []
        this.packages.forEach(couponPackage => {
          const { coupon_number, coupon_left } = couponPackage
          const value = getCouponValue(couponPackage, {
            isWashingCard: this.isWashingCard,
          })
          let counter = coupon_number
          let usedCounter = 0
          while (counter) {
            if (usedCounter < coupon_left) {
              usedCounter++
              unused.push({
                coupon_type: couponPackage.discount_type,
                value,
                cap: couponPackage.cap_text,
                product_desc: couponPackage.product_desc,
                rentFreeDays: couponPackage.rent_free_days,
                useCarDay: couponPackage.use_car_day,
                name: couponPackage.name,
                product_id: couponPackage.product_id,
                is_free: couponPackage.is_free,
              })
            } else {
              used.push({
                coupon_type: couponPackage.discount_type,
                value,
                cap: couponPackage.cap_text,
                product_desc: couponPackage.product_desc,
                rentFreeDays: couponPackage.rent_free_days,
                useCarDay: couponPackage.use_car_day,
                name: couponPackage.name,
                product_id: couponPackage.product_id,
                is_free: couponPackage.is_free,
              })
            }
            counter--
          }
        })
        if (unused.length >= 12) {
          return {
            unused: unused.slice(0, 12),
            used: [],
          }
        } else if (unused.length + used.length >= 12) {
          return {
            unused,
            used: used.slice(0, 12 - unused.length),
          }
        } else {
          return { unused, used }
        }
      } else {
        return {
          unused: [],
          used: [],
        }
      }
    },
    isWashingCard() {
      return Number(this.productType) === 492
    },
    btnText() {
      if (is('harmonyos')) return ''
      console.log('【order_car——btnText：】', this.orderId, this.productType, this.cardShow)
      const prodConfTextFromApollo = getProdConfFromApollo(this.productType, { searchKey: 'order_list' })
      const hideRideBtn = prodConfTextFromApollo?.dache_btn_hide
      if (hideRideBtn) {
        return ''
      }
      const rideTextApollo = getformateLangMessage(prodConfTextFromApollo?.dache_btn_text)
      if (rideTextApollo) {
        return rideTextApollo
      }
      return this.$t('personal.takeARide')
    },
  },
  methods: {
    downTime() {
      const current = new Date().getTime() + this.offset
      const tempTime = timeStampMs(this.expireTime) - current
      if (tempTime <= 0) {
        this.timer && clearTimeout(this.timer)
        return
      }
      this.expireDay = Math.floor(tempTime / 1000 / 60 / 60 / 24)
      this.timer = setTimeout(() => {
        this.downTime()
      }, 1000)
    },
    goDache() {
      TrackMap.personal.goRide(this.goodsId)
      goDaCheF({
        productType: this.productType,
        apolloPage: 'order_list',
      })
    },
    onClick() {
      this.triggerEvent('good-click')
    },
  },
})


  const currentOption = global.currentOption
  export default processOption(
    currentOption,
    "component",
    "",
    "index23a1b4ec",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'arrow-right':getComponent(require("../../common/arrow-right.mpx?component=true&componentId=arrow-right75d32029")),'coupon-ticket':getComponent(require("./components/coupon.mpx?component=true&componentId=coupon35b69a59")),'down-time':getComponent(require("../../../../node_modules/@didi/wyc-components/src/components/down-time/index.mpx?component=true&componentId=indexbcafbe12")),'mpx-view':getComponent(require("builtInComponent.vue!=!../../../../node_modules/@mpxjs/webpack-plugin/lib/built-in-loader!@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-view.vue?component=true"), { __mpxBuiltIn: true }),'mpx-text':getComponent(require("builtInComponent.vue!=!../../../../node_modules/@mpxjs/webpack-plugin/lib/built-in-loader!@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-text.vue?component=true"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
